<template>
  <v-card :elevation="$root.ele" class="mt-5">
    <v-data-table
      :headers="headers"
      class="templates-table"
      :items="list"
      :footer-props="{
        'items-per-page-options': [10, 20, 50, -1]
      }"
      :items-per-page="50"
    >
      <template v-slot:item.action="{ item }">
        <v-btn icon @click="$router.push(`/templates/${item.id}`)">
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:item.type="{ item }">
        {{ type(item) }}
      </template>
      <template v-slot:item.updated_by="{ item }">
        {{ updated(item) }}
      </template>
      <template v-slot:item.name="{ item }">
        <div class="text-capitalize">
          {{ item.name }}
        </div>
      </template>
    </v-data-table>
    <v-divider></v-divider>
    <infinite-loading
      ref="infinite"
      v-if="false"
      @infinite="infiniteHandler"
    ></infinite-loading>
  </v-card>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { formatDate } from "../../assets/js/common";
import { templates } from "../../assets/js/firebase";
import types from "../../assets/js/types";
export default {
  components: {
    InfiniteLoading
  },
  data() {
    return {
      lastDoc: null,
      types: types,
      id: ""
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "TEMPLATE NAME", value: "name" },
        { text: "TEMPLATE TYPE", value: "type" },
        { text: "UPDATED ON", value: "updated" },
        { text: "UPDATED BY", value: "updated_by" },
        { text: "ACTION", value: "action" }
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text,
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true
        };
        if (value === "action") doc.divider = false;
        list.push(doc);
      }
      return list;
    },
    list() {
      return this.$store.getters.templates;
    },
    users() {
      return this.$store.getters.users;
    }
  },
  methods: {
    updated({ updated_by }) {
      let name = updated_by;
      this.users.forEach(item => {
        let { email, first_name, last_name } = item;
        if (email === updated_by) name = `${first_name} ${last_name}`;
      });
      return name;
    },
    type({ type }) {
      let name = "";
      this.types.forEach(item => {
        if (item.value === type) name = item.name;
      });
      return name;
    },
    reset() {
      const vm = this;
      vm.lastDoc = null;
      vm.list = [];
      vm.$refs.infinite.stateChanger.reset();
    },
    async infiniteHandler($state) {
      const vm = this;
      try {
        let query = templates.orderBy("updated_at", "desc");
        if (vm.lastDoc !== null) query = query.startAfter(vm.lastDoc);
        let snap = await query.limit(20).get();
        if (snap.docs.length === 0) {
          if ($state !== null) $state.complete();
        } else {
          vm.list = [];
          snap.docs.forEach(item => {
            let doc = item.data();
            let { updated_at } = doc;
            if (updated_at !== "") doc.updated = formatDate(updated_at);
            console.log(doc.updated_at);
            doc.id = item.id;
            vm.list.push(doc);
            vm.lastDoc = item;
          });
          if ($state !== null) $state.loaded();
        }
      } catch (e) {
        vm.$root.alert(e.message, "Alert");
        if ($state !== null) $state.complete();
      }
    }
  }
};
</script>

<style lang="scss"></style>
